import { Chip } from '@material-ui/core'
import Typography from '@mui/material/Typography'
import { EMAIL_RECIPIENTS_TYPES } from '..'

export const SelectedRecipients = ({
  selected,
  setSelected,
  recipientsType,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          maxWidth: '100vw',
          marginTop: '1em',
        }}
      >
        {selected.length > 0 &&
          selected.map((item, key) => {
            return (
              <Chip
                key={key}
                onClick={() => {
                  setSelected(selected.filter((i) => i !== item))
                }}
                style={{
                  backgroundColor: '#FFF',
                  border: '1px solid #5f6368ba',
                  borderRadius: '50vh',
                  boxShadow: '0 0 0 1px #aeb0b5 inset',
                  margin: '.5em 0 0 .5em',
                }}
                label={item}
                onDelete={() => {
                  setSelected(selected.filter((i) => i !== item))
                }}
              />
            )
          })}
      </div>
      {recipientsType === EMAIL_RECIPIENTS_TYPES.DIRECT &&
        selected.length > 50 && (
          <Typography color="error" sx={{ marginTop: '10px' }}>
            Le nombre maximum de destinataires en envoi public est de 50. Afin
            d’envoyer ce mail, veuillez retirer des destinataires, l’envoyer en
            plusieurs parties ou bien l’envoyer en CCI
          </Typography>
        )}
    </div>
  )
}
